/* eslint-disable import/prefer-default-export */
import { createAction } from 'redux-actions';
import { THROW_FAILED } from './actionTypes';

export const manualLog = createAction(THROW_FAILED);
